module.exports = __webpack_public_path__ + "static/media/factory.cb89f5e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phaser-assets/textures/factory.png
// module id = 2734
// module chunks = 0